import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import EmojiPicker from 'emoji-picker-react';
import ChatContext from '../../context/index';
import JumpingDots from '../../Static/JumpingDots';
import SimilarListing from './SimilarListing/SimilarListing.container';

import './chatdetailfooter.scss';

const MessageTyping = ({ ...props }) => {
  const { listTypingMembers } = props;
  if (listTypingMembers !== null) {
    const TypingMembers = Object.keys(listTypingMembers).map(key => {
      return <span key={key}>{listTypingMembers[key].nickname}</span>;
    });

    return (
      <div className="message-typing">
        <div className="message-typing-text" style={{ padding: '0 4px' }}>
          <div className="message-typing-members">{TypingMembers}</div>
          <JumpingDots />
        </div>
      </div>
    );
  }
  return null;
};

const ChatDetailFooter = ({ ...props }) => {
  const [message, setMessage] = useState('');
  const [typingTimeOut, setTypingTimeOut] = useState(0);
  const [showPopup, setShowPopup] = useState({
    emojiPicker: false,
    listingContainer: false,
  });

  const { sb, trans, currentUser } = useContext(ChatContext);
  const { activeRoom, appendNewMessage, isTyping, typingMembers } = props;
  const { emojiPicker, listingContainer } = showPopup;

  const fileSelector = document.createElement('input');
  fileSelector.setAttribute('type', 'file');
  fileSelector.setAttribute('multiple', 'multiple');

  const _handleFileSelect = e => {
    if (e.target.dataset.type === 'image') {
      fileSelector.setAttribute('accept', 'image/*');
    } else {
      fileSelector.setAttribute('accept', '*');
    }
    fileSelector.click();
    setShowPopup({
      ...showPopup,
    });
  };

  const _handleSubmit = e => {
    e.preventDefault();
    if (message !== '') {
      const params = new sb.UserMessageParams();
      params.message = message;
      params.customType = 'normal';

      activeRoom.sendUserMessage(params, (messageReturn, error) => {
        if (error) {
          console.log(error);
          return;
        }
        appendNewMessage([messageReturn]);
        setMessage('');
      });
    }
  };

  const handleKeyDown = e => {
    if (e.which === 13 && !e.shiftKey) {
      _handleSubmit(e);
    }
  };

  const _handleChange = e => {
    activeRoom.startTyping();
    if (typingTimeOut) {
      clearTimeout(typingTimeOut);
    }
    setMessage(e.target.value);
    setTypingTimeOut(
      setTimeout(() => {
        activeRoom.endTyping();
      }, 1000),
    );
  };

  const _selectEmoji = (e, data) => {
    const emojiPic = String.fromCodePoint(`0x${data.unified}`);
    setMessage(`${message} ${emojiPic} `);
    setShowPopup({
      ...showPopup,
      emojiPicker: false,
    });
  };

  const _emojiPickerToggle = () => {
    setShowPopup({
      ...showPopup,
      emojiPicker: !emojiPicker,
    });
  };

  const _listingContainerToggle = () => {
    setShowPopup({
      ...showPopup,
      listingContainer: !listingContainer,
    });
  };

  fileSelector.onchange = () => {
    const files = [...fileSelector.files].map(file => ({
      id: `temp-${(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)}`,
      attachmentUrl: URL.createObjectURL(file),
      attachmentFile: file,
      _sender: currentUser,
      messageType: 'file',
      type: file.type,
    }));

    appendNewMessage([...files]);
  };

  const _sendListings = async listings => {
    if (!listings) {
      return;
    }

    const newFiles = await Promise.all(
      listings.map(async listing => {
        const params = new sb.UserMessageParams();
        params.message = listing.toString();
        params.customType = 'listing';
        const response = await activeRoom.sendUserMessage(params, (messageReturn, error) => {
          if (error) {
            console.log(error);
            return false;
          }
          return messageReturn;
        });

        return response;
      }),
    );

    appendNewMessage([...newFiles]);
    _listingContainerToggle();
  };

  const emojiPickerClass = emojiPicker ? 'show' : 'hidden';
  const listingContainerClass = listingContainer ? 'show' : 'hidden';

  return (
    <div className="chat-detail-footer">
      {isTyping ? <MessageTyping listTypingMembers={typingMembers} /> : null}
      <form onSubmit={_handleSubmit}>
        <div className="input-group">
          <div className="input-group-action-center">
            <div className="input-group-prepend">
              <button
                className="btn btn-primary emoji-picker-button"
                onClick={_emojiPickerToggle}
                type="button"
              >
                <i className="material-icons">mood</i>
              </button>
              <div className={`emoji-picker-container ${emojiPickerClass}`}>
                <EmojiPicker onEmojiClick={_selectEmoji} />
              </div>
            </div>
            <div className="input-group-prepend">
              <button className="btn btn-primary" type="button" onClick={_handleFileSelect}>
                <i className="material-icons">collections</i>
              </button>
            </div>
            <div className="input-group-prepend">
              <button className="btn btn-primary" type="button" onClick={_handleFileSelect}>
                <i className="material-icons">insert_drive_file</i>
              </button>
            </div>
            <div className="input-group-prepend">
              <button
                className="btn btn-primary emoji-picker-button"
                onClick={_listingContainerToggle}
                type="button"
              >
                <i className="material-icons-outlined">house</i>
              </button>
              {listingContainerClass && (
                <div className={`similar-listing-container ${listingContainerClass}`}>
                  <SimilarListing
                    listingContainerToggle={_listingContainerToggle}
                    sendListings={_sendListings}
                  />
                </div>
              )}
            </div>
          </div>
          <textarea
            className="form-control"
            placeholder={trans['Type your message here']}
            onChange={_handleChange}
            onKeyDown={handleKeyDown}
            value={message}
          />

          <div className="input-group-append">
            <button className="" type="submit">
              <i className="material-icons">send</i>
              {trans.Send}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

MessageTyping.defaultProps = {
  listTypingMembers: null,
};

MessageTyping.propTypes = {
  listTypingMembers: PropTypes.shape(),
};

ChatDetailFooter.defaultProps = {
  typingMembers: null,
};

ChatDetailFooter.propTypes = {
  typingMembers: PropTypes.shape(),
  activeRoom: PropTypes.shape().isRequired,
  appendNewMessage: PropTypes.func.isRequired,
  isTyping: PropTypes.bool.isRequired,
};

export default ChatDetailFooter;
